<ion-header>
  <app-page-header popoverCssClass='blog'></app-page-header>
  <app-resources-header [title]='"Teacher Blog"' [searchPlaceholder]='"Search Teacher Blog"' [showSearch]=false></app-resources-header> 
</ion-header>

<ion-content appScrollBounce>
  <div class='bottom'>
    <div [ngClass]="['contents', resourcesCssService.responsiveClass()]">
      <app-spinner-overlay [spinning]='!viewDisplayed'></app-spinner-overlay>
      <app-blog-navigation [hidden]='!viewDisplayed' [articles]=articles></app-blog-navigation>
      <article>
        <h1>{{ article.title }}</h1>
        <span class="blog-date">{{ article.createdAt.month }} {{ article.createdAt.day }}, {{ article.createdAt.year }}</span>
        <div [innerHTML]="articleContent"></div>
      </article>
    </div>
  </div> 
</ion-content>
